/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CatamaranInputs */

const en_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catamaran`)
};

const es_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catamarán`)
};

const fr_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catamaran`)
};

const de_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katamaran`)
};

const ja_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カタマラン`)
};

const zh_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双体船`)
};

const ar_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قارب طوف (Catamaran)`)
};

const id_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katamaran`)
};

const it_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catamarano`)
};

const ru_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Катамаран`)
};

const pt_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catamarã`)
};

const ko_val_catamaran = /** @type {(inputs: Val_CatamaranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카타마란`)
};

/**
* | output |
* | --- |
* | "Catamaran" |
*
* @param {Val_CatamaranInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_catamaran = /** @type {((inputs?: Val_CatamaranInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CatamaranInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_catamaran(inputs)
	if (locale === "es") return es_val_catamaran(inputs)
	if (locale === "fr") return fr_val_catamaran(inputs)
	if (locale === "de") return de_val_catamaran(inputs)
	if (locale === "ja") return ja_val_catamaran(inputs)
	if (locale === "zh") return zh_val_catamaran(inputs)
	if (locale === "ar") return ar_val_catamaran(inputs)
	if (locale === "id") return id_val_catamaran(inputs)
	if (locale === "it") return it_val_catamaran(inputs)
	if (locale === "ru") return ru_val_catamaran(inputs)
	if (locale === "pt") return pt_val_catamaran(inputs)
	return ko_val_catamaran(inputs)
});